export const snakeToCamel = (str: string): string =>
  str.replace(/([-_][a-z])/g, (group: string): string => group.toUpperCase().replace('-', '').replace('_', ''));
